import type { Layout } from "react-grid-layout"

export const spanOverviewTabLayoutLg: Record<string, Layout> = {
  SPAN_LONG_TERM_AMPACITY: {
    w: 12,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "SPAN_LONG_TERM_AMPACITY",
  },
  SPAN_LAST_AMPACITY_AAR: {
    w: 3.5,
    h: 1.5,
    x: 0,
    y: 3,
    minH: 0,
    i: "SPAN_LAST_AMPACITY_AAR",
  },
  SPAN_LAST_AMPACITY_DLR: {
    w: 3.5,
    h: 1.5,
    x: 3.5,
    y: 3,
    minH: 0,
    i: "SPAN_LAST_AMPACITY_DLR",
  },
  SPAN_BELOW_NOMINAL_AMPACITY: {
    w: 5,
    h: 1.5,
    x: 7,
    y: 3,
    minH: 0,
    i: "SPAN_BELOW_NOMINAL_AMPACITY",
  },
  SPAN_CONDUCTOR_TEMPERATURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 4.5,
    minH: 0,
    i: "SPAN_CONDUCTOR_TEMPERATURE",
  },
  SPAN_LAST_CONDUCTOR_TEMPERATURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 4.5,
    minH: 0,
    i: "SPAN_LAST_CONDUCTOR_TEMPERATURE",
  },
}
